import { render } from "./Unidade.vue?vue&type=template&id=0deb863a&scoped=true"
import script from "./Unidade.vue?vue&type=script&lang=js"
export * from "./Unidade.vue?vue&type=script&lang=js"

import "./Unidade.vue?vue&type=style&index=0&id=0deb863a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0deb863a"]])

export default __exports__